import { APP_BASE, APP_BASE_NO_SLASH, IS_V2, hasUstawotekaPathPrefix } from './baseUrl';

const joinPath = (base: string, path: string): string => {
	const p = path.replace(/^\/+/, '');
	if (base === '' || base === '/') {
		return `/${p}`;
	}
	return `${base.replace(/\/+$/, '')}/${p}`;
};

export const ustawotekaUrl = (path = ''): string => {
	if (IS_V2) {
		return joinPath(`${APP_BASE_NO_SLASH}/ustawoteka`, path);
	}
	const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
	if (hostname === 'localhost') {
		return joinPath('/ustawoteka', path);
	}
	const host = (import.meta.env.VITE_USTAWOTEKA_HOST as string | undefined)
		|| 'https://ustawoteka.iusvitae.pl';
	const cleanHost = host.replace(/\/+$/, '');
	const cleanPath = path.replace(/^\/+/, '');
	return cleanPath === '' ? `${cleanHost}/` : `${cleanHost}/${cleanPath}`;
};

export const testyUrl = (path = ''): string => {
	if (hasUstawotekaPathPrefix() || IS_V2) {
		return joinPath(APP_BASE_NO_SLASH || '/', path);
	}
	const host = (import.meta.env.VITE_TESTY_HOST as string | undefined)
		|| 'https://testy.iusvitae.pl';
	const cleanHost = host.replace(/\/+$/, '');
	const cleanPath = path.replace(/^\/+/, '');
	return cleanPath === '' ? `${cleanHost}/` : `${cleanHost}/${cleanPath}`;
};

export const adminUrl = (path = ''): string => {
	const apiHost = (import.meta.env.VITE_API_HOST as string | undefined)
		|| (typeof window !== 'undefined' ? window.location.origin : '');
	const host = apiHost.replace(/\/+$/, '');
	const cleanPath = path.replace(/^\/+/, '');
	return cleanPath === '' ? `${host}/admin` : `${host}/admin/${cleanPath}`;
};

export const gameShareUrl = (hashKey: string): string => {
	if (typeof window === 'undefined') {
		return '';
	}
	const origin = window.location.origin;
	return `${origin}${joinPath(APP_BASE_NO_SLASH || '/', `/app/games/join/${hashKey}`)}`;
};

export const newsImageUrl = (path: string): string => {
	const cleanPath = path.replace(/^\/+/, '');
	if (IS_V2) {
		const origin = typeof window !== 'undefined' ? window.location.origin : '';
		return `${origin}${joinPath(APP_BASE_NO_SLASH || '/', cleanPath)}`;
	}
	// R34b — lokalny dev: zdjęcia aktualności bierzemy z LOKALNEGO backendu,
	// nie z produkcji. Vite proxuje `/storage` → http://localhost:18000
	// (vite.config.ts), więc zwracamy ścieżkę względną — działa dla obrazów
	// zmigrowanych lokalnie (np. lektorzy), których nie ma jeszcze na prod.
	if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
		return `/${cleanPath}`;
	}
	const host = (import.meta.env.VITE_TESTY_HOST as string | undefined)
		|| 'https://testy.iusvitae.pl';
	return `${host.replace(/\/+$/, '')}/${cleanPath}`;
};
